//src/utils/whatsappOrderReviewMessages.js
export const buildReviewRequestWhatsAppMessage = (order) => {
  const firstName = order.customer?.name?.split(" ")[0] || "";
  const site = (process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace(/\/api$/, "")
  : ""
);

  const reviewLink = site
    ? `${site}/account/orders/${order.orderNumber}`
    : "";

 const message = `
Hello ${firstName},

We hope you enjoyed your order *#${order.orderNumber}* ✨  
Your feedback helps us improve and helps other customers.

Leave a review here:
${reviewLink}

—
مرحباً ${firstName}،

نأمل أن تكون قد استمتعت بطلبك رقم *${order.orderNumber}* ✨  
رأيك يهمنا ويساعدنا على تحسين خدمتنا.

اترك تقييمك هنا:
${reviewLink}

شكراً لك  
*ETIKA*
  `.trim();

  return encodeURIComponent(message);
};
